import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de médico). */
export type SolicitacaoDocumentosPjJob = ReportJob;
export type SolicitacaoDocumentosPjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Solicitação de Documentos PJ. */
@Injectable({ providedIn: 'root' })
export class SolicitacaoDocumentosPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'solicitacao-documentos-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.solicitacaoDocumentosPj;
}
